/* eslint-disable import/no-extraneous-dependencies */
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/ja";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Tokyo");
dayjs.locale("ja");

function getCurrentISO_JST() {
  return dayjs().tz("Asia/Tokyo").format();
}

function getCurrentDayjs_JST() {
  return dayjs().tz("Asia/Tokyo");
}

function getNDaysAgo_JST(n) {
  return dayjs().tz("Asia/Tokyo").subtract(n, "day");
}

function convertYYYYMMToDayjs_JST(yyyymm) {
  return dayjs(yyyymm, "YYYYMM").tz("Asia/Tokyo");
}

function convertYYYYMMDDToDayjs_JST(yyyymm) {
  return dayjs(yyyymm, "YYYYMMDD").tz("Asia/Tokyo");
}

function convertISOtoDayjs_JST(isoString) {
  return dayjs(isoString).tz("Asia/Tokyo");
}

function convertDayjsToYYYYMMDD(dayjsObj) {
  return dayjsObj.format("YYYYMMDD");
}

function isLessThan30YearsPassed(date1, date2) {
  const diffYears = date2.diff(date1, "year");
  return diffYears < 30;
}

/**
 * ISO8601形式の時刻を降順に並べ替える
 */
function sortISOStringDescending(isoString1, isoString2) {
  const date1 = new Date(isoString1);
  const date2 = new Date(isoString2);
  return date2 - date1;
}

export default {
  getCurrentISO_JST,
  getCurrentDayjs_JST,
  getNDaysAgo_JST,
  convertYYYYMMToDayjs_JST,
  convertYYYYMMDDToDayjs_JST,
  convertISOtoDayjs_JST,
  convertDayjsToYYYYMMDD,
  isLessThan30YearsPassed,
  sortISOStringDescending,
};
